export const MOCK_API = 'https://f4107b2a-4c98-4393-af0b-63bf6bd575ac.mock.pstmn.io';
export const API_HOST = process.env.REACT_APP_API_HOST;
export const apiEndpoints = {
  AUTH_LOGIN: '/auth/sendOtp',
  AUTH_OTP: '/auth/login',
  INIT: '/api/init',
  UN_AUTH_STEP: '/ua/onboarding',
  UPDATE_PROFILE: '/api/updateprofile',
  JOBS: '/jobs',
  JOBS_SHARABLE: '/jobs/sharable',
  USER_PROFILE: '/user-profiles',
  PROFILE: '/profile',
  JOB_APPLICATION: '/job-applications',
  CITIES: '/cities',
  LOCALITIES: '/localities',
  UPLOAD: '/upload',
  MITRAS: '/mitras',
  FEEDBACK_TYPES: '/feedback/types',
  FEEDBACK: '/feedback/',
  TRACK: '/track',
  REVIEWS: '/reviews',
  TRACKING_PROPERTIES: '/tracking/properties',
  JOB_CATEGORIES: '/jobs/jobCategories/types',
  JOB_REQUIREMENTS: '/jobs/requirements/types',
  USER_SETTINGS: '/user-settings',
  FB_LOGIN: '/auth/facebook',
  MITRA_CALL: '/user-job-interactions/createUserJobCall',
  FB_UPDATE_PHONE_NUMBER: '/auth/updatePhoneNumber',
  DELETE_USER: '/users/delete',
};
